export { default as LogoWithText } from "./LogoWithText"
